import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/home/footer/components/FooterClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/home/header/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/not-found/components/NotFound.tsx");
